import { Box, SxProps } from '@modusign/design-system';

interface ResourceRoleSubjectChipProps extends SxProps {
  children: string;
}

export default function ResourceRoleSubjectChip({ children, sx }: ResourceRoleSubjectChipProps) {
  return (
    <Box
      backgroundColor="statusBackgroundNeutralUltraLight"
      border="1px solid"
      borderColor="statusBorderNeutralLight"
      borderRadius="13px"
      color="textNeutralSlightlyLight"
      flex="none"
      fontSize="13px"
      fontWeight="regular"
      px="10px"
      py={2}
      sx={sx}
      whiteSpace="nowrap"
    >
      {children}
    </Box>
  );
}
